import ProductCarousel from "@/components/feature/ProductCarousel";
import useSimilarProducts from "@/hooks/useSimilarProducts";

interface SimilarProductsProps {
  currentId: number;
  category: string | null;
}

/**
 * Sección de recomendaciones "Productos similares".
 * Usa el recomendador perpetuo: siempre intenta mostrar alternativas
 * relacionadas con el artículo que se está viendo.
 */
export default function SimilarProducts({
  currentId,
  category,
}: SimilarProductsProps) {
  const { products, loading } = useSimilarProducts(currentId, category, 8);

  // Sin alternativas reales no hay nada que recomendar (no se inventan datos).
  if (!loading && products.length === 0) return null;

  return (
    <ProductCarousel
      title="Productos similares"
      products={products}
      loading={loading}
    />
  );
}